import script from "./app-amap.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-amap.vue?vue&type=script&setup=true&lang=ts"

import "./app-amap.vue?vue&type=style&index=0&id=42a2cd18&lang=scss"
import "./app-amap.vue?vue&type=style&index=1&id=42a2cd18&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a2cd18"]])

export default __exports__